
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ApiResultModel, getSubscriptionsData } from "@WhiteCap/Store/Service/SubscriptionsDasboardService";

export interface SubscriptionsDashboardApiParameter extends ApiParameter {
    customerId?: string;
    currentSessionShipToId: string;
    currentSessionBillToId: string;
    onSuccess: () => void;
    onError?: (message: string) => void;
}
type HandlerType = CustomApiHandler<SubscriptionsDashboardApiParameter, ApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    const session = getSession(props.getState());
    const { shipToId, billToId } = session;

    if (billToId !== props.apiParameter.currentSessionBillToId || shipToId !== props.apiParameter.currentSessionShipToId) {
        props.dispatch({
            type: "Custom/SubscriptionDashboard/ResetData"
        });
    }
    props.dispatch({
        type: "Custom/SubscriptionDashboard/BeginLoadData"
    });

};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getSubscriptionsData(props.apiParameter.customerId);
    if (result.successful && result.result) {
        props.apiResult = result.result;
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/LoadDataError",
        });
        return false;
    }
};

export const DispatchCompleteLoadSubscriptionsData: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/CompleteLoadData",
        result: props.apiResult,
    });
    if (props.apiResult) {
        props.apiParameter.onSuccess();
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadSubscriptionsData];

const loadSubscriptionsData = createHandlerChainRunner(chain, "GetSubscritionsData");
export default loadSubscriptionsData;
